// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportBarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import { withHandlers } from 'recompose';
import { curry, isNil, isEmpty, some } from 'lodash/fp';
import ImportOverwriteConfirmationPopup from '../Popup/Izenda.ImportOverwriteConfirmationPopup';
import MappingErrorPopup from '../Popup/Izenda.MappingErrorPopup';
import ImportProgressPopup from '../Popup/Izenda.ImportProgressPopup';

function openMappingErrorPopup(props: any, value: any) {
  props.openPopup(MappingErrorPopup, {
    errorMessages: props.store.getErrorsPopup()
  });
}

function openImportProgressPopup(props: any, importFiles: Array<any>) {
  const { store } = props;
  return props.openPopup(ImportProgressPopup, { store, importFiles });
}

function startImportProcess(props: any, value: any) {
  const { store, validation, loader } = props;
  validation.validate().then(
    action(status => {
      store.model.activeTabKey === 'report' && (store.hasErrorOnClientSideReportTab = !status);
      store.model.activeTabKey === 'dashboard' && (store.hasErrorOnClientSideDashboardTab = !status);

      if (status) {
        loader.startLoading();
        return store
          .validate()
          .then(result => {
            if (!isNil(result.messages)) {
              some({ key: 'dataModelConsistency' }, result.messages)
                ? openMappingErrorPopup(props)
                : validation.updateErrors(result.messages);
            } else {
              return validateOverwrite(props)
                .then(({ success, data }) => success && openImportProgressPopup(props, data))
                .then(store.finishImport.bind(store));
            }
          })
          .finally(loader.endLoading.bind(loader));
      }
      return Promise.resolve(false);
    })
  );
}

/**
 * Validate overwrite reports/dashboards
 * @param {any} props
 */
function validateOverwrite(props: any) {
  const { store } = props;
  return store.validateOverride().then(overwriteInfo => {
    return isEmpty(overwriteInfo.subCategories)
      ? store.beginImport()
      : props.openPopup(ImportOverwriteConfirmationPopup, { store, overwriteInfo }).then(store.beginImport.bind(store));
  });
}

/**
 * Update import access rights
 * @param {Object} props
 */
function updateImportAccessRights(props: any, value: any) {
  const { store: { model } } = props;
  model.toggleImportAccessRights();
}

/**
 * Update import access rights
 * @param {Object} props
 */
function updateImportCategory(props: any, value: any) {
  const store = props.store;
  store.toggleImportCategory();
}

/**
 * Update import the filter values
 * @param {Object} props
 */
function updateImportTheFilterValues(props: any, value: any) {
  const { store: { model } } = props;
  model.toggleImportTheFilterValues();
}

const actions = withHandlers({
  startImportProcess: curry(startImportProcess),
  updateImportAccessRights: curry(updateImportAccessRights),
  updateImportTheFilterValues: curry(updateImportTheFilterValues),
  updateImportCategory: curry(updateImportCategory)
});

export default actions;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/ActionBar/Izenda.ImportBarActions.js